import React from "react";
import { motion } from "framer-motion";
import "./Contact.css";
import contactSideImg from "../../assets/ContactPage.png";

const Contact = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <div className="contact-page-wrapper">
      <header className="contact-header-top">
        <div className="container text-center mt-5">
          <motion.h1 initial="hidden" animate="visible" variants={fadeInUp}>
            Contact Dazbog
          </motion.h1>
        </div>
      </header>

      <section className="contact-main-section">
        <div className="container">
          <div className="contact-grid-layout">
            {/* Left: Message Form */}
            <motion.div
              className="contact-form-box"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <h2>Send Us A Message</h2>
              <p>
                Have a project in mind or a question for our team? Share your
                details and we'll get back to you.
              </p>

              <form className="dazbog-contact-form">
                <div className="contact-row">
                  <div className="contact-input-grp">
                    <label>First Name</label>
                    <div className="icon-input">
                      <i className="bi bi-person"></i>
                      <input type="text" placeholder="Enter first name" />
                    </div>
                  </div>
                  <div className="contact-input-grp">
                    <label>Last Name</label>
                    <div className="icon-input">
                      <i className="bi bi-person"></i>
                      <input type="text" placeholder="Enter last name" />
                    </div>
                  </div>
                </div>

                <div className="contact-row">
                  <div className="contact-input-grp">
                    <label>Phone Number</label>
                    <div className="icon-input">
                      <i className="bi bi-telephone"></i>
                      <input type="tel" placeholder="Enter phone number" />
                    </div>
                  </div>
                  <div className="contact-input-grp">
                    <label>Email Address</label>
                    <div className="icon-input">
                      <i className="bi bi-envelope"></i>
                      <input type="email" placeholder="Enter email address" />
                    </div>
                  </div>
                </div>

                <div className="contact-input-grp full-width">
                  <label>Enter Message</label>
                  <div className="icon-input align-top">
                    <i className="bi bi-chat-left-dots"></i>
                    <textarea
                      rows="5"
                      placeholder="Enter your message"
                    ></textarea>
                  </div>
                </div>

                <button type="submit" className="submit-enquiry-btn">
                  Submit Enquiry
                </button>
              </form>
            </motion.div>

            {/* Right: Thematic Image */}
            <motion.div
              className="contact-img-right"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
            >
              <img
                src={contactSideImg}
                alt="Solar Energy Field"
                className="contact-side-img"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* SECTION 2: Vertical Contact Cards */}
      <section className="contact-details-cards">
        <div className="container">
          <div className="details-grid">
            <div className="detail-v-card">
              <div className="detail-v-icon">
                <i className="bi bi-geo-alt"></i>
              </div>
              <span className="detail-v-label">Address</span>
              <p className="detail-v-value">
                DLF Corporate Greens, Sector 74-1, <br /> Gurugram - 122004,
                Haryana, India
              </p>
            </div>

            <div className="detail-v-card">
              <div className="detail-v-icon">
                <i className="bi bi-envelope"></i>
              </div>
              <span className="detail-v-label">Email</span>
              <p className="detail-v-value">info@dazbog.in</p>
            </div>

            <div className="detail-v-card">
              <div className="detail-v-icon">
                <i className="bi bi-phone"></i>
              </div>
              <span className="detail-v-label">Call Us</span>
              <p className="detail-v-value">+91 88009 54675</p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3: Google Map Area */}
      <section className="contact-map-section">
        <div className="map-container">
          <iframe
            title="Dazbog Office Location" // Added this to fix the warning
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.324158434771!2d76.99450377549265!3d28.40951167578749!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d160063aaa7c1%3A0x2bc8afcea924832f!2sDLF%20CORPORATE%20GREENS!5e0!3m2!1sen!2sin!4v1707810000000!5m2!1sen!2sin"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Contact;

